/**
 * @module LatLng
 *
 * @see LatLng
 */

import * as math from '../math';

import { createSchemaBasedConstructor } from './create-typed-constructor';

const LatLng = createSchemaBasedConstructor('LatLng');

/**
 *
 * (principally because proj4 expects points to have (x,y) fields)
 * @sig toXY :: (LatLng) -> { x: Lng, y:  Lat }
 */
LatLng.toXY = latLng => ({ x: latLng.lng, y: latLng.lat });

/**
 *
 * (principally because proj4 expects points to have (x,y) fields)
 * @sig fromXY :: { x: Number, y:  Number } -> LatLng
 */
LatLng.fromXY = ({ x, y }) => LatLng.from({ lng: x, lat: y });

/**
 *
 * (principally because proj4 expects points to have (x,y) fields)
 * @sig fromXY :: [Lng, Lat] -> LatLng
 */
LatLng.fromArray = a => LatLng.from({ lng: a[0], lat: a[1] });

/**
 * @sig fromLatAndLng :: (Lat, Lng) -> LatLng
 */
LatLng.fromLatAndLng = (lat, lng) => LatLng.from({ lat, lng });

/**
 * @sig fromLatitudeAndLongitude :: ({ latitude: Number, longitude: Number }) -> LatLng
 */
LatLng.fromLatitudeAndLongitude = ({ latitude, longitude }) => LatLng.from({ lat: latitude, lng: longitude });

/**
 * @sig toString :: LatLng -> String
 */
LatLng.toString = latLng => `[${latLng.lat}, ${latLng.lng}]`;

/**
 * Calculate the Great-Circle distance (in meters) between two LatLngs
 *
 * @sig distance :: (LatLng, LatLng) -> Number
 */
LatLng.greatCircleDistance = (p1, p2) => math.greatCircleDistance(p1.lat, p1.lng, p2.lat, p2.lng);

export default LatLng;
